import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[70vh] flex items-center justify-center pt-32 px-6"
    >
      <div className="text-center max-w-lg">
        <p className="text-[11px] tracking-[0.35em] uppercase text-[#C8A24B]">
          404
        </p>
        <h1 className="mt-3 font-display text-5xl md:text-6xl text-[#1F3B2D]">
          Page not found.
        </h1>
        <p className="mt-4 text-[#4A5550]">
          The page you were after has wandered off. Let’s get you back on track.
        </p>
        <Link to="/" className="btn-primary mt-8 inline-flex" data-testid="not-found-home">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
